export default __webpack_public_path__ + "c93963a1a204b6cdb0677c975a78442b.svg";